import { useCallback } from 'react';
import { useCartStore } from '../store/useCartStore';
import { Product } from '../types/product';
import toast from 'react-hot-toast';

export const useCart = () => {
  const { items, addItem, removeItem, updateQuantity, clearCart, subtotal, shipping, tax, itemCount, total } = useCartStore();

  const handleAddToCart = useCallback((product: Product, quantity: number = 1) => {
    addItem(product, quantity);
    toast.success(`${product.name} added to cart!`, {
      icon: '🛒',
      style: {
        background: '#4169E1',
        color: '#fff',
      },
    });
  }, [addItem]);

  const handleRemoveFromCart = useCallback((productId: string) => {
    const item = items.find(i => i.productId === productId);
    if (item) {
      removeItem(productId);
      toast.success(`${item.name} removed from cart`, {
        icon: '🗑️',
      });
    }
  }, [items, removeItem]);

  const handleUpdateQuantity = useCallback((productId: string, quantity: number) => {
    updateQuantity(productId, quantity);
  }, [updateQuantity]);

  const handleClearCart = useCallback(() => {
    clearCart();
    toast.success('Cart cleared', {
      icon: '✨',
    });
  }, [clearCart]);

  const isInCart = useCallback((productId: string) => {
    return items.some(item => item.productId === productId);
  }, [items]);

  const getCartItem = useCallback((productId: string) => {
    return items.find(item => item.productId === productId);
  }, [items]);

  return {
    items,
    subtotal,
    shipping,
    tax,
    itemCount,
    total,
    addToCart: handleAddToCart,
    removeFromCart: handleRemoveFromCart,
    updateQuantity: handleUpdateQuantity,
    clearCart: handleClearCart,
    isInCart,
    getCartItem,
  };
};

